import Lock from '../helpers/lock';
export default class Auth {
    static getLockHandler() {
        if (this.lockHandler === null) {
            this.lockHandler = new Lock();
        }
        return this.lockHandler;
    }
    /**
     * Pobierz ostatni zapamiętany stan autoryzacji
     */
    static getLastState() {
        try {
            const data = localStorage.getItem('auth_state');
            if (data === null) {
                return null;
            }
            return JSON.parse(data);
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }
    /**
     * Pobierz najświeższy stan autoryzacji
     *
     * Jeżeli na danej podstronie nie był weryfikowany to zostanie pobrany z API.
     */
    static async getState() {
        // Tylko jeden proces jednocześnie może uzyskiwać dostęp do stanu z API
        await this.getLockHandler().acquireLock();
        if (this.summary !== null) {
            this.getLockHandler().releaseLock();
            return this.summary;
        }
        const lastState = this.getLastState();
        const wasLoggedIn = lastState !== null && lastState.loggedIn === true;
        // Wczytanie z API
        try {
            this.summary = await this.getSummaryFromApi();
        }
        catch (e) {
            this.getLockHandler().releaseLock();
            throw e;
        }
        // Zapamiętanie stanu
        localStorage.setItem('auth_state', JSON.stringify(this.summary));
        // Zwolnienie blokady
        this.getLockHandler().releaseLock();
        // Powiadomienie innych mechanizmów o zmianie stanu zalogowania
        if (wasLoggedIn !== this.summary.loggedIn) {
            this.triggerListeners(this.summary);
        }
        return this.summary;
    }
    static async getSummaryFromApi() {
        const response = await fetch('/api/v1/customer/auth-state', {
            method: 'GET',
            cache: 'no-cache',
        });
        if (!response.ok) {
            throw new Error('Failed to get auth state');
        }
        return (await response.json());
    }
    /**
     * Dodaj funkcję nasłuchującą na zmianę stanu zalogowania
     * @param fn Funkcja wykonywana w momencie detekcji zmiany stanu zalogowania
     */
    static addListener(fn) {
        this.listeners.push(fn);
    }
    /**
     * Zakomunikuj nasłuchującym elementom o zmianie stanu zalogowania
     * @param newState Nowy stan zalogowania
     */
    static triggerListeners(newState) {
        this.listeners.forEach((fn) => {
            fn(newState);
        });
    }
}
Auth.summary = null;
Auth.lockHandler = null;
Auth.listeners = [];
